<template>
  <screen-base title="Éphéméride" :sub-title="date">
    <div class="column">
      <screen-card-weather :data="data.weather" />
      <screen-card-ephemeris class="last-item" :data="data.ephemeris" />
    </div>
    <div v-if="!isWidgetDisplay" class="column">
      <screen-card-team class="full-height-item" :data="data.team" />
    </div>
    <div v-else class="column">
      <screen-card-widgets :widgets="widgets" />
    </div>
  </screen-base>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator"
import DateHelper from "../../helpers/DateHelper"
import { EphemerisSlideFragment, ScreenWidgetList } from "../../queries/screen/graphql"

@Component({
  components: {
    "screen-base": () => import("./screen-base.vue"),
    "screen-card-weather": () => import("./screen-card-weather.vue"),
    "screen-card-ephemeris": () => import("./screen-card-ephemeris.vue"),
    "screen-card-team": () => import("./screen-card-team.vue"),
    "screen-card-widgets": () => import("./screen-card-widgets.vue"),
  },
})
export default class ScreenEphemeris extends Vue {
  @Prop({ type: Object, required: true }) readonly data!: EphemerisSlideFragment
  @Prop({ type: Number, required: true }) readonly timer!: number
  @Prop({ type: Object, required: true }) readonly widgets!: ScreenWidgetList

  isWidgetDisplay = false
  interval: ReturnType<typeof setInterval> | undefined

  get date() {
    return DateHelper.getDateStringFormat(new Date(), "EEEE d MMMM yyyy").toUpperCase()
  }

  created() {
    const minSwitchInterval = Math.min((this.timer * 1000) / 2, 10 * 1000)

    this.interval = setInterval(() => {
      this.isWidgetDisplay = !this.isWidgetDisplay && this.widgets.widgets.length > 0
    }, minSwitchInterval)
  }

  destroyed() {
    clearInterval(this.interval)
  }
}
</script>
<style scoped lang="scss">
.column {
  width: 49.8%;
  height: 100%;
  padding: 2.63%;
  display: inline-block;
  vertical-align: top;

  .last-item {
    margin-top: 10.76%;
  }

  .full-height-item {
    height: 100%;
  }
}
</style>
